import { createSelector } from 'reselect'

const SORT_BY_STATE = {
  // Order désiré : dispo > à l'approche > (en tournée en cours > en tournée (autre) > en tournée mais pas présent) > planifié > pas de plan > caché
  'wait': 40, // dispo
  'returning': 30, // à l'approche
  'run': 20, // en tournée en cours
  'run_other': 20, // en tournée (autre)
  'run_not_present': 20, // en tournée mais pas présent
  'plan': 10, // planifié
  'noplan': 5, // pas de plan
  'hidden': 0, // caché
};

const getDrivers = state => state.m.drivers
const getLaunchpad = (state, props) => props.launchpad

export const getFilteredDrivers = createSelector(
  [getDrivers, getLaunchpad],
  (drivers, launchpad) => {
    return drivers.map(d => Object.assign({}, d))
      .filter(d => d.launchpad === launchpad)
      .sort((a, b ) => {
        if (a.state === b.state) {
          if (a.eta_comparable === b.eta_comparable ) {
            return (a.name <= b.name ? -1 : 1);
          } else {
            return (a.eta_comparable <= b.eta_comparable ? -1 : 1);
          }

        }
        const av = SORT_BY_STATE[a.state] || 0;
        const bv = SORT_BY_STATE[b.state] || 0;
        return av > bv ? -1 : 1;
      });
  }
)
